import React from 'react'
import { Container } from 'reactstrap'
import Breadcrumbs from '../../components/Global/Breadcrumbs' 
import Table from './components/Datatable'

const Index = () => {
    return(
        <React.Fragment>
            <div id="mainContent" className="page mainContent">
                <Container fluid>
                    <Breadcrumbs
                        title="Configuraciones / Usuarios"
                        breadcrumbItem={`Usuarios`}
                        parentLink={`/configuracion/usuarios`}
                    />

                    <Table />
                </Container>
            </div>
        </React.Fragment>
    )
}

export default Index